export const useGFALExStore = defineStore("GFALEx", () => {
  const { $serverApi } = useNuxtApp();
  const GFALExSnapshot = ref({} as Quote);
  const GFALExRate = ref(0);

  const convertToUSD = (amount: string) => {
    return amount && /^([0-9]+)?(\.[0-9]+)?$/.test(amount)
      ? roundNum(Number(amount) * GFALExRate.value)
      : roundNum(0.0);
  };

  const setGFALEx = (snapshot: Quote) => {
    GFALExSnapshot.value = snapshot;
    GFALExRate.value = snapshot.price;
  };

  const getGFALExSnapshot = async () => {
    try {
      const response = await $fetch<GFALResponse<Quote> | Quote>(
        "/api/rates/gfal-usd",
      );
      const snapshot =
        response && typeof response === "object" && "payload" in response
          ? (response.payload as Quote)
          : (response as Quote);
      if (snapshot) {
        setGFALEx(snapshot);
      }
      return snapshot;
    } catch {
      try {
        const response = await $serverApi<GFALResponse<Quote> | Quote>(
          "/api/rates/gfal-usd",
        );
        const snapshot =
          response && typeof response === "object" && "payload" in response
            ? (response.payload as Quote)
            : (response as Quote);
        if (snapshot) {
          setGFALEx(snapshot);
        }
        return snapshot;
      } catch {
        return null;
      }
    }
  };

  return {
    GFALExSnapshot,
    GFALExRate,
    convertToUSD,
    setGFALEx,
    getGFALExSnapshot,
  };
});
